var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 130.019,
    viewBox: "0 0 150 130.019",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "camera",
    transform: "translate(-70.747 -94.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3884",
    "data-name": "Path 3884",
    d: "M145.729,224.709q-27.966,0-55.932,0c-11.177,0-19.047-7.891-19.048-19.089q0-35.934,0-71.869c0-11.167,7.9-19.031,19.1-19.035,6.406,0,12.811-.027,19.217.026,1.062.009,1.563-.27,1.873-1.318.678-2.291,1.456-4.557,2.286-6.8a18.029,18.029,0,0,1,16.915-11.891q15.623-.079,31.247,0a18,18,0,0,1,16.894,11.915c.8,2.144,1.537,4.312,2.177,6.506a1.851,1.851,0,0,0,2.155,1.6c6.457-.085,12.915-.046,19.373-.037,10.775.015,18.749,7.971,18.754,18.75q.02,36.247,0,72.494c-.005,10.769-7.99,18.74-18.762,18.747Q173.852,224.722,145.729,224.709Zm-.066-10q27.96,0,55.919,0c5.77,0,9.157-3.354,9.158-9.073q.006-35.925,0-71.851c0-5.665-3.376-9.065-9-9.069q-11.871-.011-23.742,0c-2.953,0-4.524-1.121-5.479-3.919-1.142-3.345-2.229-6.708-3.367-10.055a8.226,8.226,0,0,0-8.333-6.019q-15.073-.017-30.146,0a8.22,8.22,0,0,0-8.333,6.018c-1.118,3.3-2.188,6.613-3.305,9.912-1.005,2.969-2.544,4.061-5.695,4.063q-11.715.009-23.43,0c-5.841,0-9.16,3.344-9.16,9.222q0,35.769,0,71.538c0,5.941,3.321,9.234,9.308,9.234Q117.859,214.711,145.663,214.709Z",
    transform: "translate(0 0)",
    fill: "#fffbf5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3885",
    "data-name": "Path 3885",
    d: "M160.738,216.253a37.5,37.5,0,1,1,37.436,37.48A37.518,37.518,0,0,1,160.738,216.253Zm64.995-.009a27.5,27.5,0,1,0-27.395,27.488A27.527,27.527,0,0,0,225.733,216.244Z",
    transform: "translate(-52.492 -49.023)",
    fill: "#fffbf5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3886",
    "data-name": "Path 3886",
    d: "M363.761,190.744a5,5,0,1,1-5.036,4.908A5.03,5.03,0,0,1,363.761,190.744Z",
    transform: "translate(-167.977 -56.027)",
    fill: "#fffbf5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.fe0dbd97cc7e31419a3e76f9916aae36.svg";
export { ForwardRef as ReactComponent };